/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowSewingWorkshopTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowSewingWorkshop,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Sew Together!",
    "Sewing Workshop Awaits!",
    "Create with Fabric!",
  ],
  title: "Sewing Workshop",
  description: "Organize a creative sewing workshop.",
  longDescription:
    "Gather your friends for a sewing workshop! Choose a date, decide on projects to work on, and plan activities for the session!",
  emoji: "🧵",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Sewing Workshop",
          emoji: "🧵",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the sewing workshop?",
          emoji: "📅",
          completeAction: {
            question: "Decide on projects to create?",
            description:
              "What sewing projects should we work on during the workshop?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What projects should we consider?",
                emoji: "🧶",
                completeAction: {
                  question: "Decide on materials needed?",
                  description: "What materials should we gather for sewing?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What materials should we bring?",
                      emoji: "🧵",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Create Something Beautiful!",
    outroDescription: "Your sewing workshop plans are set! Enjoy the crafting!",
  },
};
